import { io } from 'socket.io-client';
import { getSocketBase, getAuthToken, getServerMode } from './api';

let socket = null;

// Only the Express app (Oracle, "Local Server" mode) runs a Socket.IO
// server. The default "Cloud" mode is a Cloudflare Worker with no
// persistent-connection support -- Chat.js falls back to polling there.
export function socketSupported() {
  return getServerMode() === 'local';
}

export function getSocket() {
  if (!socketSupported()) return null;
  const token = getAuthToken();
  if (!token) return null;

  if (!socket) {
    socket = io(getSocketBase(), {
      auth: { token },
      autoConnect: false,
      transports: ['websocket', 'polling'],
    });
  } else {
    socket.auth = { token };
  }

  if (!socket.connected) socket.connect();
  return socket;
}

export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
